import { useMemo, useState } from "react";

// Common markets first; full ISO list available via search.
export const COMMON = ["GB", "US", "CA", "IE", "AU", "NZ", "FR", "DE", "ES", "IT", "NL", "IN", "CN", "HK", "SG", "JP", "ZA", "AE", "MX", "BR",
  "PT", "SE", "NO", "FI", "RU", "UA", "HR", "CZ", "MN", "KR", "AR", "IL", "MY", "BE", "CH", "AT", "PL", "DK", "GR", "TR",
  "AZ", "ID", "PK", "NG", "EG", "PH", "GH", "KE", "UG", "MW", "JM", "TT", "BS", "BB", "MT", "FJ", "ZW", "ZM"];
export const ALL_CODES = "AD AE AF AG AL AM AO AR AT AU AZ BA BB BD BE BF BG BH BI BJ BN BO BR BS BT BW BY BZ CA CD CF CG CH CI CL CM CN CO CR CU CV CY CZ DE DJ DK DM DO DZ EC EE EG ER ES ET FI FJ FM FR GA GB GD GE GH GM GN GQ GR GT GW GY HK HN HR HT HU ID IE IL IN IQ IR IS IT JM JO JP KE KG KH KI KM KN KP KR KW KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MG MH MK ML MM MN MO MR MT MU MV MW MX MY MZ NA NE NG NI NL NO NP NR NZ OM PA PE PG PH PK PL PT PW PY QA RO RS RU RW SA SB SC SD SE SG SI SK SL SM SN SO SR SS ST SV SY SZ TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VN VU WS YE ZA ZM ZW".split(" ");
const names = typeof Intl !== "undefined" && Intl.DisplayNames ? new Intl.DisplayNames(["en-GB"], { type: "region" }) : null;
export const countryName = (c) => { try { return names?.of(c) || c; } catch { return c; } };

export default function CountryPicker({ value, onChange, testid }) {
  const [q, setQ] = useState("");
  const all = value.length === 0;
  const list = useMemo(() => {
    const t = q.trim().toLowerCase();
    const codes = t ? ALL_CODES.filter((c) => c.toLowerCase().includes(t) || countryName(c).toLowerCase().includes(t)) : COMMON;
    return [...new Set([...codes, ...value])];
  }, [q, value]);
  const toggle = (c) => onChange(value.includes(c) ? value.filter((x) => x !== c) : [...value, c]);

  return (
    <div data-testid={testid}>
      <label className="flex items-center gap-2 text-sm font-semibold mb-2">
        <input type="checkbox" checked={all} onChange={() => onChange(all ? ["GB"] : [])} data-testid={`${testid}-all`} className="w-4 h-4 accent-rf-orange" />
        All countries — worldwide, every country in the world
      </label>
      <p className="text-xs text-slate-500 mb-2" data-testid={`${testid}-priority-note`}>
        If several themes run on the same day, the one aimed at the fewest countries shows (e.g. a New Zealand-only day beats a Halloween week for 5 countries, which beats a worldwide theme). Ties go to the shorter date range.
      </p>
      {!all && (
        <>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search any country…" data-testid={`${testid}-search`} className="input-rf !py-1.5 text-sm mb-2" />
          <div className="flex flex-wrap gap-1.5 max-h-60 overflow-y-auto">
            {list.map((c) => (
              <label key={c} className={`inline-flex items-center gap-1 px-2 py-1 rounded-full border text-xs cursor-pointer ${value.includes(c) ? "bg-rf-amber/30 border-rf-amber" : "bg-white border-rf-ink/15"}`}>
                <input type="checkbox" checked={value.includes(c)} onChange={() => toggle(c)} data-testid={`${testid}-${c}`} className="w-3 h-3 accent-rf-orange" />
                {countryName(c)}
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
